<template>
  <!-- 添加一个场景页面 -->
  <!-- 设置页面的内容区域 -->
  <div class="config_main_manage_page_wraper">
    <div class="config_main_manage_page_content">
      <!-- 设置页面  内容区域样式   以上部分都是公共样式 -->

      <!-- <config-title-hang class="cofig_title_hang_height_device_object_detaile"></config-title-hang> -->
      <config-title-hang>
        <span slot="config_title_hang_ele2">定时任务</span>
      </config-title-hang>

      <config-hang
        :switchState=" serveOneCycTask027Data.taskStatus "
        @click.native="showifBtnHandle"
      >
        <span slot="config_hang_ele2">周期定时状态</span>
        <img slot="config_hang_switchBtn_open" src="~assets/img/config/zhu_kai.png" alt />
        <img slot="config_hang_switchBtn_close" src="~assets/img/config/zhu_guan.png" alt />
      </config-hang>

      <config-hang inputID="xiugaiName2">
        <span slot="config_hang_ele2">定时打开时间</span>
        <span slot="config_hang_ele_tishi">24小时制时间</span>
        <img slot="config_hang_xiugai" src="~assets/img/config/xiugai.png" alt />
        <input
          type="text"
          slot="config_hang_input_right_hour"
          id="xiugaiName3"
          placeholder="小时"
          v-model="serveOpenHour"
          onkeyup="this.value=this.value.replace(/\D/g,'')"
          onafterpaste="this.value=this.value.replace(/\D/g,'')"
        />
        <span slot="config_hang_ele_fenhao">:</span>
        <input
          type="text"
          slot="config_hang_input_right_min"
          id="xiugaiName2"
          placeholder="分钟"
          v-model="serveOpenMin"
          onkeyup="this.value=this.value.replace(/\D/g,'')"
          onafterpaste="this.value=this.value.replace(/\D/g,'')"
        />
      </config-hang>

      <config-hang inputID="xiugaiName5">
        <span slot="config_hang_ele2">定时关闭时间</span>
        <span slot="config_hang_ele_tishi">24小时制时间</span>
        <img slot="config_hang_xiugai" src="~assets/img/config/xiugai.png" alt />
        <input
          type="text"
          slot="config_hang_input_right_hour"
          id="xiugaiName4"
          placeholder="小时"
          v-model="serveCloseHour"
          onkeyup="this.value=this.value.replace(/\D/g,'')"
          onafterpaste="this.value=this.value.replace(/\D/g,'')"
        />
        <span slot="config_hang_ele_fenhao">:</span>
        <input
          type="text"
          slot="config_hang_input_right_min"
          id="xiugaiName5"
          placeholder="分钟"
          v-model="serveCloseMin"
          onkeyup="this.value=this.value.replace(/\D/g,'')"
          onafterpaste="this.value=this.value.replace(/\D/g,'')"
        />
      </config-hang>

      <config-hang @click.native="cycleConfig022Btnhandle">
        <span slot="config_hang_ele2">重复周期设置</span>
        <img slot="config_hang_ele4" src="~assets/img/config/youjiantou.png" alt />
        <!-- <span slot="config_hang_ele3">{{serveOneCycTask027Data.weeks}}</span> -->
        <span slot="config_hang_022_ele3">{{computerCycleConfigShow}}</span>
      </config-hang>

      <!-- 未完成的工作  这里要根据有没有周期定时ID去判断一下  是新添加的还是修改的  添加和修改的接口都没有写呢-->
      <div class="public_config_que_ren_btn" @click="saveReturnBtnHandle">保存并返回</div>
    </div>
  </div>
</template>

<script>
import configHang from "components/common/config/config-hang";
import configTitleHang from "components/common/config/config-title-hang";
import { configPageDataRequest } from "views/afterLogin/config/deviceManagePage/deviceListPage/public_config_requery_js";
import {
  // deviceTypeJudge,
  // deviceTypeJudge1,
  publicDeviceTypeJudge
  // deviceStateFlip
} from "components/content/contro-view/device-view/device-item-view-js";
export default {
  data() {
    return {
      ServeOneObjectinfo: {
        ////地址指向仓库
      },
      serveOpenHour: "", ////打开的小时
      serveOpenMin: "", ///打开的分钟
      serveCloseHour: "", ////打开的小时
      serveCloseMin: "", ///打开的分钟
      serveOneCycTask027Data: {
        /////一个周期定时任务的数据
      }
    };
  },
  computed: {
    computerCycleConfigShow() {
      let cycleShow = "";
      let count = 0;
      if (this.serveOneCycTask027Data.weeks.indexOf("1") != -1) {
        cycleShow += "周一 ";
        count++;
      }
      if (this.serveOneCycTask027Data.weeks.indexOf("2") != -1) {
        cycleShow += "周二 ";
        count++;
      }
      if (this.serveOneCycTask027Data.weeks.indexOf("3") != -1) {
        cycleShow += "周三 ";
        count++;
      }
      if (this.serveOneCycTask027Data.weeks.indexOf("4") != -1) {
        cycleShow += "周四 ";
        count++;
      }
      if (this.serveOneCycTask027Data.weeks.indexOf("5") != -1) {
        cycleShow += "周五 ";
        count++;
      }
      if (this.serveOneCycTask027Data.weeks.indexOf("6") != -1) {
        cycleShow += "周六 ";
        count++;
      }
      if (this.serveOneCycTask027Data.weeks.indexOf("7") != -1) {
        cycleShow += "周日 ";
        count++;
      }
      if (count >= 7) {
        cycleShow = "每天";
      }
      return cycleShow;
    }
  },
  components: {
    configHang,
    configTitleHang
  },
  methods: {
    showifBtnHandle() {
      // 定时任务状态按钮按下了
      if (this.serveOneCycTask027Data.taskStatus === 1) {
        this.serveOneCycTask027Data.taskStatus = 0;
      } else {
        this.serveOneCycTask027Data.taskStatus = 1;
      }
    },
    saveReturnBtnHandle() {
      if (!this.input027Judge()) {
        return;
      }
      console.log(!this.input027Judge());
      // return
      console.log("1111222");
      ////保存并返回按钮按下了
      if (this.serveOneCycTask027Data.cycleId === "") {
        ////说明是添加一个新的定时数据
        ////插座添加周期定时任务  接口
        this.$request({
          method: "post",
          url: "/device/saveCycleTime",
          data: {
            token: this.$store.state.token,
            deviceId: this.serveOneCycTask027Data.deviceId,
            // cycleId: this.serveOneCycTask027Data.cycleId,
            weeks: this.serveOneCycTask027Data.weeks,
            taskStatus: this.serveOneCycTask027Data.taskStatus,
            openTime: this.serveOneCycTask027Data.openTime,
            closeTime: this.serveOneCycTask027Data.closeTime
          }
        })
          .then(res => {
            if (res.data.code != 0) {
              this.$showTipsToast(3, res.data.message);
              ////说明信息填写错误,控制失败了，
              return;
            } else {
              ////、控制成功了
              // this.serveCycleTaskData = res.data.data ////拿到服务器返回的数据结果
              console.log(res.data.data);
              this.$showTipsToast(1, "添加成功", true); ////提示框
              this.$router.go(-1);
            }
          })
          .catch(error => {
            console.log(error);
          });
      } else {
        ///说明书修改老的定时数据
        ////插座修改插座周期定时任务  接口
        this.$request({
          method: "post",
          url: "/device/updateCycleTimeById",
          data: {
            token: this.$store.state.token,
            cycleId: this.serveOneCycTask027Data.cycleId,
            weeks: this.serveOneCycTask027Data.weeks,
            taskStatus: this.serveOneCycTask027Data.taskStatus,
            openTime: this.serveOneCycTask027Data.openTime,
            closeTime: this.serveOneCycTask027Data.closeTime
          }
        })
          .then(res => {
            if (res.data.code != 0) {
              this.$showTipsToast(3, res.data.message);
              ////说明信息填写错误,控制失败了，
              return;
            } else {
              ////、控制成功了
              // this.serveCycleTaskData = res.data.data ////拿到服务器返回的数据结果
              console.log(res.data.data);
              this.$showTipsToast(1, "修改成功", true); ////提示框
              this.$router.go(-1);
            }
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    input027Judge() {
      if (this.serveOneCycTask027Data.taskStatus === "") {
        this.$toast("开关状态不能为空！");
        return false;
      } else if (
        this.serveOneCycTask027Data.openTime === "" &&
        this.serveOneCycTask027Data.closeTime === ""
      ) {
        this.$toast("至少设置一个打开或关闭的定时时间！");
        return false;
      } else if (this.serveOneCycTask027Data.weeks === "") {
        this.$toast("重复周期不能为空！");
        return false;
      } else {
        // console.log(this.serveOpenHour)
        // console.log(this.serveOpenMin)

        // console.log(this.serveCloseHour)

        // console.log(this.serveCloseMin)


        if (this.serveOneCycTask027Data.openTime != "") {
          //说明设置了打开时间，检查打开时间的格式是否正确
          console.log(this.serveOpenHour)
          console.log(this.serveOpenMin)

          if (this.serveOpenHour == '' || this.serveOpenMin == '') {
            this.$toast("请填写完整的打开时间");
            return false;
          }
        }
        if (this.serveOneCycTask027Data.closeTime != "") {
          //说明设置了关闭时间，检查关闭时间的格式是否正确
          if (this.serveCloseHour== ''  || this.serveCloseMin == '' ) {
            this.$toast("请填写完整的关闭时间");
            return false;
          }
        }
        return true;
      }
    },
    cycleConfig022Btnhandle() {
      // this.$router.push("cycleConfig022Page");
      this.$router.push({ path: "cycleConfig022Page", query: { type: "027" } });
    }
  },
  watch: {
    ////实时监测用户输入的时间是否合法
    serveOpenHour(val) {
      console.log(val + typeof val);
      if (val === "") {
        this.serveOneCycTask027Data.openTime = ""; ////用户可以不填时间
        return;
      }
      if (Number(val) < 0) {
        this.serveOpenHour = "";
      } else if (Number(val) > 23) {
        this.serveOpenHour = 23;
      } else {
        this.serveOpenHour = Number(val);
      }
      this.serveOneCycTask027Data.openTime =
        this.serveOpenHour + ":" + this.serveOpenMin;
      console.log(this.serveOneCycTask027Data.openTime);
    },
    ////实时监测用户输入的时间是否合法
    serveOpenMin(val) {
      console.log(val + typeof val);

      if (val === "") {
        this.serveOneCycTask027Data.openTime = ""; ////用户可以不填时间
        this.serveOpenMin = "";
        return;
      }

      if (Number(val) < 0) {
        this.serveOpenMin = "0";
      } else if (Number(val) > 59) {
        this.serveOpenMin = "59";
      } else {
        this.serveOpenMin = Number(val);
      }

      this.serveOneCycTask027Data.openTime =
        this.serveOpenHour + ":" + this.serveOpenMin;
      console.log(this.serveOneCycTask027Data.openTime);
    },
    ////实时监测用户输入的时间是否合法
    serveCloseHour(val) {
      console.log(val + typeof val);
      if (val === "") {
        this.serveOneCycTask027Data.closeTime = ""; ////用户可以不填时间
        return;
      }

      if (Number(val) < 0) {
        this.serveCloseHour = 0;
      } else if (Number(val) > 23) {
        this.serveCloseHour = 23;
      } else {
        this.serveCloseHour = Number(val);
      }
      this.serveOneCycTask027Data.closeTime =
        this.serveCloseHour + ":" + this.serveCloseMin;
      console.log(this.serveOneCycTask027Data.closeTime);
    },
    ////实时监测用户输入的时间是否合法
    serveCloseMin(val) {
      console.log(val + typeof val);
      if (val === "") {
        this.serveOneCycTask027Data.closeTime = ""; ////用户可以不填时间
        return;
      }
      if (Number(val) < 0) {
        this.serveCloseMin = "0";
      } else if (Number(val) > 59) {
        this.serveCloseMin = "59";
      } else {
        this.serveCloseMin = Number(val);
      }

      this.serveOneCycTask027Data.closeTime =
        this.serveCloseHour + ":" + this.serveCloseMin;
      console.log(this.serveOneCycTask027Data.closeTime);
    }
  },
  mounted() {
    console.log("mounted阶段");
  },
  created() {
    console.log("created阶段");
    this.serveOneCycTask027Data = this.$store.state.configinfo.serveOneCycTask027Data; ////一个对象的地址信息拿过来
    console.log(this.serveOneCycTask027Data);
    console.log(this.ServeOneObjectinfo);
    ///定时设备对象需要处理一下定时时间 打开的时间
    if (this.serveOneCycTask027Data.openTime != "") {
      ///处理拿到的时间
      this.serveOpenHour = this.serveOneCycTask027Data.openTime.match(
        /(\S*):/
      )[1]; ////拿到时间之后  取出：之前的小时 取字符串
      this.serveOpenMin = this.serveOneCycTask027Data.openTime.match(
        /:(\S*)/
      )[1]; ////拿到时间之后  取出：之后的分钟 取字符串
    }
    ///定时设备对象需要处理一下定时时间 关闭的时间
    if (this.serveOneCycTask027Data.closeTime != "") {
      ///处理拿到的时间
      this.serveCloseHour = this.serveOneCycTask027Data.closeTime.match(
        /(\S*):/
      )[1]; ////拿到时间之后  取出：之前的小时 取字符串
      this.serveCloseMin = this.serveOneCycTask027Data.closeTime.match(
        /:(\S*)/
      )[1]; ////拿到时间之后  取出：之后的分钟 取字符串
    }

    // console.log(this.serveOneCycTask027Data);
  }
};

/**
 * 
 *    此页面进入之前1，得到 asyUpdataServeOneObjectinfo这个数据提交到仓库  2，传参跳页面  如下举例
 *       // 获取设备详情 接口，获取数据
      this.$request({
        method: "post",
        url: "/device/findDeviceById",
        data: {
          token: this.$store.state.token,
          deviceId: deviceId
        }
      })
        .then(res => {
          if (res.data.code != 0) {
            this.$showTipsToast(3, res.data.message);
            ////说明信息填写错误,控制失败了，
            return;
          } else {
            ////、控制成功了 数据地址存到仓库
            this.$store.dispatch("asyUpdataServeOneObjectinfo", res.data.data); ///异步提交对象信息地址到仓库

            // 进入下一个页面
            this.$router.push({
              path: "deviceObjectDetails",
              query: {
                title: title,  
                deviceId: deviceId,
                productCode: productCode
              }
            });
            // this.$showTipsToast(1, "获取成功", true); ////提示框
          }
        })
        .catch(error => {
          console.log(error);
        });
 */
</script>

<style>
</style>